// @ts-check
import required from 'utils/required';

import {
  REQUESTING_COST_ESTIMATE,
  RECEIVE_COST_ESTIMATE,
  RESET_COST_ESTIMATE,
} from 'agent_portal/actions/CostEstimateActions';

const initialState = {
  isFetching: false,
  costEstimate: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTING_COST_ESTIMATE:
      return { ...state, isFetching: true };
    case RECEIVE_COST_ESTIMATE:
      const { costEstimate = required('costEstimate') } = action.payload;
      return {
        ...state,
        isFetching: false,
        costEstimate,
      };
    case RESET_COST_ESTIMATE:
      return {
        isFetching: false,
        costEstimate: null,
      };
    default:
      return state;
  }
};

export default reducer;
